import { Modules } from '@enum/central/modules.enum';
import { CommonPerm } from '@enum/common/permission/common-perm.enum';
import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';

export const ConfigurationSection = [
  {
    section: 'Configurações',
    // A união das permissões de TODAS as telas da seção, na ordem dos itens.
    // Faltavam `Templates_View`, `Workflows_View`, `Layout_Edit`,
    // `AccessKeys_View`, `DataMigration_View` e `BackupData_View`: quem só
    // tinha uma delas via o item sem o título da seção.
    permission: [
      '*',
      TenantPerm.StandardLaunch_View, TenantPerm.Categories_View,
      TenantPerm.Categories_Create, TenantPerm.Categories_Update,
      TenantPerm.Subsidiaries_View,
      TenantPerm.Templates_View, TenantPerm.Workflows_View, TenantPerm.Layout_Edit,
      TenantPerm.BankSlip_Configure, TenantPerm.CardReceiving_Configure, TenantPerm.PaymentLinks_Configure,
      TenantPerm.FiscalRps_Configure,
      TenantPerm.Contracts_Settings,
      TenantPerm.Dashboard_Summary, TenantPerm.Dashboard_Cashbox, TenantPerm.Dashboard_Delinquency,
      TenantPerm.Dashboard_Cashflow, TenantPerm.Dashboard_Card, TenantPerm.Dashboard_Results,
      TenantPerm.Dashboard_InOut, TenantPerm.Dashboard_InByCategory, TenantPerm.Dashboard_OutByCategory,
      TenantPerm.EmailTypes_View, TenantPerm.PhoneTypes_View,
      TenantPerm.DocumentProfiles_View,
      CommonPerm.Roles_View, CommonPerm.Users_View,
      TenantPerm.AccessKeys_View,
      TenantPerm.DataMigration_View,
      TenantPerm.BackupData_View,
    ],
  },
  {
    title: 'Contador',
    permission: ['*', CommonPerm.Users_View],
    root: true,
    icon: 'calculate',
    page: '/painel/configuracoes/contador',
    bullet: 'dot',
  },
  {
    title: 'Plano de contas',
    root: true,
    icon: 'savings',
    bullet: 'dot',
    permission: [
      '*',
      TenantPerm.StandardLaunch_View, TenantPerm.Categories_View,
      TenantPerm.Categories_Create, TenantPerm.Categories_Update,
    ],
    submenu: [
      {
        title: 'Contas contábeis',
        permission: ['*', TenantPerm.StandardLaunch_View],
        root: true,
        page: '/painel/lancamento-contabil',
        bullet: 'dot',
      },
      {
        title: 'Categorias',
        permission: ['*', TenantPerm.Categories_View],
        root: true,
        page: '/painel/categorias',
        bullet: 'dot',
      },
      // Centros de custo mudou de Parâmetros para cá (dono, 21/09/2026). A rota
      // continua a mesma; só a entrada do menu mudou de lugar.
      {
        title: 'Centros de custo',
    module: Modules.COST_CENTERS,
        permission: ['*', TenantPerm.Categories_View, TenantPerm.Categories_Create, TenantPerm.Categories_Update],
        root: true,
        bullet: 'dot',
        page: '/painel/configuracoes/centros-de-custo',
      },
    ],
  },
  {
    title: 'Filiais',
    module: Modules.SUBSIDIARIES,
    permission: ['*', TenantPerm.Subsidiaries_View],
    root: true,
    icon: 'apartment',
    page: '/painel/fiscal/filiais/list',
    bullet: 'dot',
  },
  {
    title: 'Cobranças',
    root: true,
    icon: 'campaign',
    bullet: 'dot',
    permission: ['*', TenantPerm.Templates_View, TenantPerm.Workflows_View, TenantPerm.Layout_Edit],
    submenu: [
      {
        title: 'Layout',
        permission: ['*', TenantPerm.Layout_Edit],
        root: true,
        bullet: 'dot',
        page: '/painel/configuracoes/cobranca/layout',
      },
      {
        title: 'Templates',
        permission: ['*', TenantPerm.Templates_View],
        root: true,
        page: '/painel/configuracoes/cobranca/templates',
        bullet: 'dot',
      },
      {
        title: 'Régua de cobrança',
    module: Modules.WORKFLOWS,
        permission: ['*', TenantPerm.Workflows_View],
        root: true,
        page: '/painel/configuracoes/cobranca/fluxo',
        bullet: 'dot',
      },
      {
        title: 'Destinatários adicionais',
        permission: ['*', TenantPerm.Workflows_View],
        root: true,
        page: '/painel/configuracoes/cobranca/copia',
        module: Modules.WORKFLOWS,
        bullet: 'dot',
      },
    ],
  },
  // Recebimentos, Nota fiscal e Contratos saíram de Parâmetros e viraram
  // itens da seção (dono, 21/09/2026). "Boleto bancário" deixou de ter item
  // próprio: a rota antiga redireciona para Recebimentos. As rotas das telas
  // continuam as mesmas.
  //
  // Recebimentos: boleto, PIX, cartão e link de pagamento — a permissão é a
  // mesma união que a guarda da rota declara.
  {
    title: 'Recebimentos',
    permission: [
      '*',
      TenantPerm.BankSlip_Configure,
      TenantPerm.CardReceiving_Configure,
      TenantPerm.PaymentLinks_Configure,
    ],
    root: true,
    icon: 'payments',
    bullet: 'dot',
    page: '/painel/configuracoes/recebimentos',
  },
  {
    title: 'Nota fiscal',
    permission: ['*', TenantPerm.FiscalRps_Configure],
    root: true,
    icon: 'receipt',
    bullet: 'dot',
    page: '/painel/configuracoes/fiscal-rps',
  },
  // Era "Contratos e assinaturas" (dono: o nome é só "Contratos").
  {
    title: 'Contratos',
    module: Modules.CONTRACTS,
    permission: ['*', TenantPerm.Contracts_Settings],
    root: true,
    icon: 'draft',
    bullet: 'dot',
    page: '/painel/configuracoes/contratos',
  },
  // As chaves de categoria do dashboard, que eram uma aba da gaveta do painel
  // (dono, 26/09/2026). A permissão é a da API (`StatsController.php:49-59`).
  {
    title: 'Dashboard',
    permission: [
      '*',
      TenantPerm.Dashboard_Summary, TenantPerm.Dashboard_Cashbox, TenantPerm.Dashboard_Delinquency,
      TenantPerm.Dashboard_Cashflow, TenantPerm.Dashboard_Card, TenantPerm.Dashboard_Results,
      TenantPerm.Dashboard_InOut, TenantPerm.Dashboard_InByCategory, TenantPerm.Dashboard_OutByCategory,
    ],
    root: true,
    icon: 'bar_chart',
    bullet: 'dot',
    page: '/painel/configuracoes/dashboard',
  },
  {
    title: 'Parâmetros',
    // A união das permissões dos filhos. "Minha assinatura" foi para o menu
    // do usuário (rodapé do menu lateral).
    permission: [
      '*',
      TenantPerm.EmailTypes_View, TenantPerm.PhoneTypes_View,
      TenantPerm.DocumentProfiles_View,
      CommonPerm.Roles_View,
    ],
    root: true,
    bullet: 'dot',
    icon: 'settings',
    submenu: [
      // A lista reúne e-mails, telefones e os tipos de endereço do sistema.
      {
        title: 'Tipos de contato e endereço',
        permission: ['*', TenantPerm.EmailTypes_View, TenantPerm.PhoneTypes_View],
        root: true,
        bullet: 'dot',
        page: '/painel/configuracoes/tipos-de-contato',
      },
      {
        title: 'Perfil de documentos',
        permission: ['*', TenantPerm.DocumentProfiles_View],
        root: true,
        bullet: 'dot',
        page: '/painel/perfil-de-documentos',
      },
      {
        title: 'Cargos e permissões',
        permission: ['*', CommonPerm.Roles_View],
        root: true,
        page: '/painel/cargos',
        bullet: 'dot',
      },
    ],
  },
  {
    title: 'Api',
    permission: ['*', TenantPerm.AccessKeys_View],
    root: true,
    icon: 'code',
    page: '/painel/configuracoes/chave-acesso-api',
    module: Modules.PUBLIC_API,
    bullet: 'dot',
  },
  {
    title: 'Migração de dados',
    permission: ['*', TenantPerm.DataMigration_View],
    root: true,
    icon: 'swap_horiz',
    bullet: 'dot',
    submenu: [
      {
        title: 'Importação',
        permission: ['*', TenantPerm.DataMigration_View],
        root: true,
        page: '/painel/configuracoes/migracao/importacao',
        bullet: 'dot',
      },
      {
        title: 'Exportação',
        permission: ['*', TenantPerm.DataMigration_View],
        root: true,
        page: '/painel/configuracoes/migracao/exportacao',
        bullet: 'dot',
      },
    ],
  },
  {
    title: 'Cópia de segurança',
    permission: ['*', TenantPerm.BackupData_View],
    root: true,
    icon: 'database',
    page: '/painel/configuracoes/copia-de-seguranca',
    bullet: 'dot',
  },
];
